import { render, staticRenderFns } from "./ShowDataVerrify.vue?vue&type=template&id=89a34512&scoped=true&"
import script from "./ShowDataVerrify.vue?vue&type=script&lang=js&"
export * from "./ShowDataVerrify.vue?vue&type=script&lang=js&"
import style0 from "./ShowDataVerrify.vue?vue&type=style&index=0&id=89a34512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a34512",
  null
  
)

export default component.exports